module.exports = __webpack_public_path__ + "img/br.41d7ec94.svg";